import DOMPurify from "isomorphic-dompurify";

export const injectPurifiedHTML = (htmlContent: string) => ({
  __html: DOMPurify.sanitize(htmlContent),
});
